<template>
  <section class="services">
    <h2 class="services__title">{{ isEnglish ? 'Our services' : 'Nos services' }}</h2>
    <div class="services__grid">
      <ServiceCard 
        v-for="service in localizedServices" 
        :key="service.id"
        :title="service.name"
        :description="service.description"
        :color="service.color"
        :with-cta="withCta"
        :to="service.route"
        :cta-text="isEnglish ? 'Learn more' : 'En savoir plus'"
      />
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import ServiceCard from '@/components/ui/ServiceCard.vue'

export default {
  name: 'ServicesSection',
  components: {
    ServiceCard
  },
  props: {
    withCta: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(['services']),
    
    // Vérifier si on est en anglais
    isEnglish() {
      return this.$route.meta?.locale === 'en';
    },
    
    // Propriété pour détecter la langue actuelle
    currentLocale() {
      return this.$route.meta?.locale || 'fr';
    },
    
    // Services localisés selon la langue actuelle
    localizedServices() {
      return this.services.map(service => {
        const newService = { ...service };
        
        // Utiliser le nom et la description en anglais si on est en mode anglais
        if (this.isEnglish) {
          newService.name = service.nameEn || service.name;
          newService.description = service.descriptionEn || service.description;
        }
        
        // Ajouter la route en fonction du type de service
        let route = null;
        
        // Ajouter la route en fonction du type de service (nom d'origine pour la logique)
        if (service.name.toLowerCase().includes('chatbot')) {
          route = '/chatbot';
        } else if (service.name.toLowerCase().includes('saas')) {
          route = '/saas';
        } else if (service.name.toLowerCase().includes('seo')) {
          route = '/seo';
        } else if (service.name.toLowerCase().includes('no-code') || service.name.toLowerCase().includes('nocode')) {
          route = '/nocode';
        } else if (service.name.toLowerCase().includes('data')) {
          route = '/datascience';
        }
        
        // Localiser la route si nécessaire et si elle existe
        if (route && this.isEnglish) {
          route = `/en${route}`;
        }
        
        newService.route = route;
        return newService;
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.services {
  padding: $spacing-md 0 $spacing-xl; /* Au lieu de $spacing-xl 0 */
  
  &__title {
    font-size: 24px;
    font-weight: bold;
    color: $dark-text;
    margin-bottom: $spacing-lg;
  }
  
  &__grid {
  display: flex;
  flex-wrap: wrap;
  gap: $spacing-md;
  justify-content: center;
  
  & > * {
    flex: 0 0 auto;
    width: 100%;
    max-width: 350px;
    
    @media (min-width: $breakpoint-sm) {
      width: calc(50% - #{$spacing-md});
    }
    
    @media (min-width: $breakpoint-lg) {
      width: calc(33.333% - #{$spacing-md});
    }
  }
}
}
</style>